
<div :id="attachId" class="h-100 w-100 position-relative">
  <input type="text" style="position: absolute;top: 20px;width: 61%;outline: none;left: 10px;opacity: 40;z-index: -999999;" :value="selectedOption[itemValue]" :required="required">
  <label v-if="label" class="mb-0 c-label">{{ label }}</label>
  <div v-if="disabled || readonly" :style="disabledStyle" class="c-select-new position-relative flex-grow-1 w-100 d-block not-selectable d-flex align-items-center">
    <span v-if="value" class="mr-2"> {{formattedText(selectedOption[itemText])}}</span>
    <span v-else class="text-grey mr-2">{{ placeholder }}</span>
    <div style="position: absolute; right: 3px;">
      <v-icon :style="'transform: rotate(180deg);'">mdi-chevron-up</v-icon>
    </div>
  </div>
  <div v-else-if="disabledChevron" :style="disabledChevronStyle" class="c-select-new position-relative flex-grow-1 w-100 d-block not-selectable d-flex align-items-center">
    <span v-if="value" class="mr-2"> {{formattedText(selectedOption[itemText])}}</span>
    <span v-else class="text-grey mr-2">{{ placeholder }}</span>
  </div>
  <v-menu :attach="attach ? '#' + attachId : attach" v-else v-model="isOpen" style="width: 100%; padding: 2px; z-index:9999 " :close-on-content-click="false" content-class="mt-1 font-lato" offset-y bottom>
    <template v-slot:activator="{ on, attrs }">
      <div @click="isOpen=true" id="c-select-new" class="c-select-new position-relative flex-grow-1 w-100 d-block not-selectable d-flex align-items-center" role="button" v-bind="attrs" v-on="on">
        <span v-if="value" class="mr-3" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; flex: 1;">
          <v-icon dense class="mr-1" v-if="selectedOption['icon']">{{ selectedOption['icon'] }}</v-icon>
          <span :title="formattedText(selectedOption[itemText])">
            {{formattedText(selectedOption[itemText])}}
          </span>
        </span>
        <span v-else class="text-grey mr-2">{{ placeholder }}</span>
        <div style="position: absolute; right: 3px;">
          <v-icon :style="attrs['aria-expanded'] == 'false' && 'transform: rotate(180deg) !important;'">mdi-chevron-up</v-icon>
        </div>
      </div>
    </template>
    <div class="bg-white border" style="border-radius: 5px;max-height: 300px;overflow: auto;">
      <div
        class="c-select-tag-input w-100 bg-white"
        v-for="(option, i) of options"
        :key="i"
    >
      <div class="d-flex align-items-center">
        <div v-if="!option['disabled'] || value == option[itemText]" role="button" @click="onSelected(option[itemValue])" class="m-0 w-100 px-4 py-2 text-truncate" style="max-width: 100%;">
          <slot name="item" :option="option">
            <v-icon v-if="option['icon']" dense class="mr-1">{{ option['icon'] }}</v-icon>
            <span :title="formattedText(option[itemText])">{{ formattedText(option[itemText]) }}</span>
          </slot>
        </div>
        <div class="m-0 px-4 py-2 w-100 text-grey text-truncate"  style="max-width: 250px;" v-else>
          <slot name="item" :option="option">
            <v-icon v-if="option['icon']" dense class="mr-1">{{ option['icon'] }}</v-icon>
            <span :title="formattedText(option[itemText])">{{ formattedText(option[itemText]) }}</span>
          </slot>
        </div>
      </div>
    </div>
    </div>
  </v-menu>
</div>
